import { Box, Flex, List, ListItem, UnorderedList } from "@chakra-ui/react";
import AppText, { LinkText } from "../../Core/AppText/AppText";

const NotFoundComponent: React.FC = () => {
	return (
		<Flex height="100vh" alignItems="center" justifyContent="center">
			<Box maxW={"500px"}>
				<AppText size="l" weight="bold">
					Sidan kunde inte hittas
				</AppText>

				<AppText size={"l"} margin="0.5rem 0">
					Det kan till exempel bero på:
				</AppText>
				<UnorderedList>
					<ListItem>
						<AppText size="l">
							Sidan finns inte, i sådana fall gå{" "}
							<LinkText size="l" as="a" href="/overview">
								hit
							</LinkText>{" "}
							eller navigera tillbaka i din webbläsare.
						</AppText>
					</ListItem>
					<ListItem>
						<AppText size="l">
							Du har blivit utloggad på grund av inaktivitet eller att sessionen löpt ut, tryck{" "}
							<LinkText size="l" as="a" href="/login">
								här
							</LinkText>{" "}
							för att komma till inloggning.
						</AppText>
					</ListItem>
				</UnorderedList>
			</Box>
		</Flex>
	);
};

export default NotFoundComponent;
